export enum SsoType {
  Email = 'Email',
  Kakao = 'Kakao',
  Twitter = 'Twitter',
  Naver = 'Naver',
  Google = 'Google',
  Apple = 'Apple',
  Ridi = 'Ridi',
}

export const SsoTypeString: Record<SsoType, string> = {
  [SsoType.Email]: '이메일',
  [SsoType.Kakao]: '카카오',
  [SsoType.Twitter]: '트위터',
  [SsoType.Naver]: '네이버',
  [SsoType.Google]: '구글',
  [SsoType.Apple]: 'Apple',
  [SsoType.Ridi]: '리디',
};

export const SsoTypeUrlString: Record<SsoType, string> = {
  [SsoType.Email]: 'email',
  [SsoType.Kakao]: 'kakao',
  [SsoType.Twitter]: 'twitter',
  [SsoType.Naver]: 'naver',
  [SsoType.Google]: 'google',
  [SsoType.Apple]: 'apple',
  [SsoType.Ridi]: 'ridi',
};

export enum SsoLinkCode {
  NotAuthorized = 'NotAuthorized',
  AlreadyLinked = 'AlreadyLinked',
  NotYetUnlinkTermination = 'NotYetUnlinkTermination',
  Unknown = 'Unknown',
  Success = 'Success',
}
